export default {
  ALIGNER_ORDER: 'ALIGNER_ORDER',
  PLANNING_ORDER: 'PLANNING_ORDER',
} as const
